import React from 'react';
import BuyerInfoSection from "./BuyerInfo/BuyerInfoSection";
import PassengersList from "../../features/passengersList/components/PassengersList";
import SubmissionForm from "./SubmissionForm/SubmissionForm";
import Voucher from "./Voucher/Voucher";
import PaymentSection from "./Summary/PaymentSection";
import AddonsSection from "@CheckOrder/features/addons/components/AddonsSection";
import Column from "@Containers/components/Column";
import AdditionalTicketInfo from "@CheckOrder/components/MainSection/AdditionalTicketInfo/AdditionalTicketInfo";
import {isEmpty} from "@Array/isEmpty";
import AncillariesSection from "@CheckOrder/features/ancillaries/components/AncillariesSection";
import SeatPickerSection from "@CheckOrder/components/MainSection/SeatPicker/components/SeatPickerSection";
import {SeatPickerDataType} from "@CheckOrder/components/MainSection/SeatPicker/types/SeatPickerData.type";
import AmenityGroups from "@CheckOrder/features/amenities/components/AmenityGroups";
import {AmenitiesType} from "@CheckOrder/features/amenities/types/Amenities.type";
import {
    TicketAdditionalFieldsPerDirectionType
} from "@CheckOrder/features/TicketAdditionalInfo/types/TicketAdditionalFieldsPerDirection.type";

type CheckOrderMainSectionProps = {
    isIntermodal: boolean,
    hasAddons: boolean,
    additionalTicketFields: TicketAdditionalFieldsPerDirectionType,
    seatPickerData: SeatPickerDataType,
    amenities: AmenitiesType,
    passengerClasses: any[],
}

const CheckOrderMainSection = (props: CheckOrderMainSectionProps) => {
    const {
        isIntermodal,
        hasAddons,
        additionalTicketFields,
        seatPickerData,
        amenities,
        passengerClasses,
    } = props

    const displaySeatPickerSection = seatPickerData?.singleSeatPicker.seatPicker || seatPickerData?.returnSeatPicker.seatPicker;
    const showTicketInfoSection = !isEmpty(additionalTicketFields.singleAdditionalFields.additionalTicketFields) || !isEmpty(additionalTicketFields.returnAdditionalFields.additionalTicketFields);

    return (
        <div className="check-order__main">
            <Column className="gb--card gb--check-order-passengers">
                <PassengersList/>
                {hasAddons && (
                    <AddonsSection/>
                )}
            </Column>
            {!!amenities && (
                <AmenityGroups
                    amenities={amenities}
                />
            )}
            {displaySeatPickerSection && (
                <SeatPickerSection
                    seatPickerData={seatPickerData}
                />
            )}
            {showTicketInfoSection && (
                <AdditionalTicketInfo
                    additionalTicketFields={additionalTicketFields}
                />
            )}
            <BuyerInfoSection/>
            <AncillariesSection/>
            {!isIntermodal && (
                <Voucher/>
            )}
            <PaymentSection/>
            <SubmissionForm/>
        </div>
    )
};

export default CheckOrderMainSection;